
import videojs from "video.js";
import "video.js/dist/video-js.css";
export default {
  name: "VideoPlayer",
  props: {
    video: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      player: null,
      path: "",
      token: "",
    };
  },
  methods: {
    async setVideos() {
      if (this.video.videoPath !== "") {
        const videoSlashLength = this.video.videoPath.split("/");
        if (videoSlashLength.length > 1) {
          const url = await this.$api.get(
            `Videos/GetCDNStream/${this.video.id}`
          );
          if (url.message === "OK") {
            this.path = url.data.link;
            this.token = url.data.token;
          }
        } else {
          this.path = this.$api.path(
            `Videos/GetStream/${this.video.id}/720/part.m3u8`
          );
          this.token = "";
        }
      }
      this.startVideo();
    },
    startVideo() {
      const vm = this;
      videojs.Vhs.xhr.beforeRequest = (option) => {
        if (!option.uri.includes("part.m3u8"))
          option.uri = option.uri + "?jwt_token=" + vm.token;
        return option;
      };
      this.player = videojs(
        this.$refs.videoPlayer,
        {
          live: true,
          autoplay: false,
          controls: true,
          playbackRates: [0.5, 1, 1.5, 2],
          sources: [{ src: this.path, type: "application/x-mpegURL" }],
        },
        () => {
          setTimeout(() => {
            this.$emit("video:init", vm.player);
          }, 150);
          this.player.on("play", function () {
            vm.$emit("video:play", vm.player);
          });
          this.player.on("playing", function () {
            vm.$emit("video:playing", vm.player);
          });

          this.player.on("pause", function () {
            vm.$emit("video:pause", vm.player);
          });

          this.player.on("seeking", function () {
            vm.$emit("video:seeking", vm.player);
          });

          this.player.on("seeked", function () {
            vm.$emit("video:seeked", vm.player);
          });

          this.player.on("ended", function () {
            vm.$emit("video:ended", vm.player);
          });
          this.player.on("error", function () {
            vm.$emit("video:error", vm.player);
          });
        }
      );
    },
  },
  mounted() {
    this.setVideos();
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
    }
  },
};
